import React from "react";
import { ActivityContent } from "./activity-content";


type Props = {
  interestID: string;
}

const ActivityPage: React.FC<Props> = (props) => (
  <ActivityContent
    interestID={props.interestID}
  />
);

export default ActivityPage;
